import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SiteDTO } from '@beable/roster-backend-client-v1';
import { StyledPanelHeader } from '../Common/Layout/PanelHeader';
import { BasePanelBox } from '../Common/Layout/BasePanelBox';
import BasePanel from '../Common/Layout/BasePanel';
import { getStyles } from './styles';
import EmployeeSiteSelector from '../EmployeeBatch/EmployeeSiteSelector';

interface PersonalizePanelProps {
    onSiteSelect: (site: SiteDTO) => void;
}

export default function PersonalizePanel({ onSiteSelect }: PersonalizePanelProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <BasePanel>
      <BasePanelBox>
        <StyledPanelHeader header='Personalize Evaluator Accounts' />
        <Box sx={{
          p: 4
        }}>
          <Box sx={styles.provisionSelector}>
            <EmployeeSiteSelector
              siteId={undefined}
              onSelect={onSiteSelect}
            />
          </Box>
        </Box>
      </BasePanelBox>
    </BasePanel>
  );
}
